import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const activityAndMovementPageGradients: Gradient[] = [
  {
    hex: '#E8DFD2',
    id: 'orange-1',
    opacity: 1,
    position: [80, 68],
    shape: 'circle',
    size: 15,
  },
  {
    hex: '#E8DFD2',
    id: 'orange-2',
    opacity: 1,
    position: [10, 28],
    shape: 'circle',
    size: 11,
  },
  {
    hex: '#E8DFD2',
    id: 'orange-3',
    opacity: 1,
    position: [15, 97],
    shape: 'circle',
    size: 16,
  },
  {
    hex: '#FDFAF7',
    id: 'orange-4',
    opacity: 1,
    position: [45, 78],
    shape: 'circle',
    size: 13,
  },
];

export default activityAndMovementPageGradients;
